module.exports = __webpack_public_path__ + "static/media/ad-1.b5d8e421.png";